import { render, staticRenderFns } from "./UiImageCard.vue?vue&type=template&id=2b74d6f9&scoped=true&"
import script from "./UiImageCard.vue?vue&type=script&lang=ts&"
export * from "./UiImageCard.vue?vue&type=script&lang=ts&"
import style0 from "./UiImageCard.vue?vue&type=style&index=0&id=2b74d6f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74d6f9",
  null
  
)

export default component.exports